import { create } from 'zustand'

export const useIncomeStore = create((set) => ({
  income: null,
  setIncome: (income) => set(() => {
    return {income};
  }),
}))
